export default __webpack_public_path__ + "static/media/southkorea.01fb90d0.svg";